export default function SocialButton({
    socialURL,
    socialIcon
}) {
    return (
        <a
            className="w-[24px] lg:w-[48px]"
            href={socialURL}
            target="_blank"
            rel="noreferrer"
        >{socialIcon}</a>
    )
}